module.exports = __webpack_public_path__ + "static/Dark-Blue-1163238b51cbe39d20b14bd6246ad098.png";